var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.292787 21.7072C0.105316 21.5197 0 21.2654 0 21.0002C0 20.735 0.105316 20.4807 0.292787 20.2932L9.58579 11.0002L0.292787 1.70722C0.110629 1.51861 0.0098342 1.26601 0.0121126 1.00381C0.014391 0.741617 0.11956 0.490805 0.304968 0.305397C0.490376 0.119987 0.741189 0.0148182 1.00339 0.0125408C1.26558 0.0102615 1.51818 0.111055 1.70679 0.293215L11.7068 10.2932C11.8943 10.4807 11.9996 10.7351 11.9996 11.0002C11.9996 11.2654 11.8943 11.5197 11.7068 11.7072L1.70679 21.7072C1.51926 21.8947 1.26495 22 0.999786 22C0.734622 22 0.480314 21.8947 0.292787 21.7072Z",
    fill: "#2E2C21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightNew);
export default __webpack_public_path__ + "static/media/arrowRightNew.eec1732f64bdd92e7847cbd7d764858c.svg";
export { ForwardRef as ReactComponent };